import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { ROUTES } from 'config/routes';
import LoadingSkeleton from 'components/feedback/LoadingSkeleton';
import {
  HomePage,
  CatalogPage,
  CategoryPage,
  SubcategoryPage,
  BrandPage,
  BrandsPage,
  PromotionsPage,
  NewsPage,
  ProductDetailPage,
  SearchResultsPage,
  CartPage,
  OrderTrackingPage,
} from 'pages';

const Lazy = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingSkeleton rows={3} height={80} />}>{children}</Suspense>
);

export const publicRoutes = (
  <>
    <Route index element={<Lazy><HomePage /></Lazy>} />
    <Route path={ROUTES.CATALOG} element={<Lazy><CatalogPage /></Lazy>} />
    <Route path={ROUTES.CATEGORY} element={<Lazy><CategoryPage /></Lazy>} />
    <Route path={ROUTES.SUBCATEGORY} element={<Lazy><SubcategoryPage /></Lazy>} />
    <Route path={ROUTES.PRODUCT} element={<Lazy><ProductDetailPage /></Lazy>} />
    <Route path={ROUTES.SEARCH} element={<Lazy><SearchResultsPage /></Lazy>} />
    <Route path={ROUTES.BRANDS} element={<Lazy><BrandsPage /></Lazy>} />
    <Route path={ROUTES.BRAND} element={<Lazy><BrandPage /></Lazy>} />
    <Route path={ROUTES.PROMOTIONS} element={<Lazy><PromotionsPage /></Lazy>} />
    <Route path={ROUTES.NEWS} element={<Lazy><NewsPage /></Lazy>} />
    <Route path={ROUTES.CART} element={<Lazy><CartPage /></Lazy>} />
    <Route path={ROUTES.ORDER_TRACKING} element={<Lazy><OrderTrackingPage /></Lazy>} />
  </>
);
